import { useQuery } from "@tanstack/react-query";
import { hubFetch } from "../lib/auth.js";

export interface AuditRow {
  id: number;
  ts: number;
  actor_kind: string;
  actor_id: string;
  action: string;
  target: string;
  meta_json: string | null;
}

export function useAudit(filters: { actor?: string; action?: string; target?: string }) {
  const params = new URLSearchParams();
  if (filters.actor) params.set("actor", filters.actor);
  if (filters.action) params.set("action", filters.action);
  if (filters.target) params.set("target", filters.target);
  const qs = params.toString();
  return useQuery({
    queryKey: ["admin", "audit", qs],
    queryFn: async () => {
      const res = await hubFetch<{ items: AuditRow[] }>(
        `/admin/audit${qs ? `?${qs}` : ""}`,
      );
      return res.items;
    },
    staleTime: 10_000,
  });
}
